import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcEarthWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.1512,
			cy: 12.1275,
			r: 7.20296,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.05773 17.2206C9.40855 18.5714 11.2406 19.3303 13.151 19.3303C15.0613 19.3303 16.8934 18.5714 18.2443 17.2206C19.5951 15.8698 20.354 14.0377 20.354 12.1273C20.354 10.217 19.5951 8.38487 18.2443 7.03406L13.151 12.1273L8.05773 17.2206Z",
			fill: "#C4D7FD"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.21 4.63357L20.5223 5.32131C22.0648 7.14578 22.9371 9.44925 22.9665 11.8317C22.9994 14.5034 21.9695 17.0557 20.1002 18.925C18.5284 20.4968 16.4737 21.4751 14.2712 21.7271V23.3118H16.6512V24.2078H10.9953V23.3118H13.3752V21.7891C13.2528 21.7921 13.13 21.7928 13.0069 21.7913C10.6245 21.7619 8.32109 20.8897 6.49664 19.3472L5.65676 20.187L5.02319 19.5535L7.14418 17.4325L7.77775 18.0661L7.13264 18.7112C8.7914 20.0914 10.8717 20.8689 13.018 20.8953C15.4516 20.9254 17.7705 19.9876 19.4667 18.2915C21.1628 16.5953 22.1006 14.2764 22.0706 11.8428C22.0441 9.69647 21.2665 7.61608 19.8863 5.9573L19.089 6.75455L18.4554 6.12099L20.5764 4L21.21 4.63357Z",
			fill: "white"
		})
	]
});
export default SvgIcEarthWhite;
